// extracted by mini-css-extract-plugin
var _1 = "callCenter__zB6Lk";
var _2 = "mark__qajaA";
var _3 = "title__ysez4";
var _4 = "value__c0g2t";
export { _1 as "callCenter", _2 as "mark", _3 as "title", _4 as "value" }
export default { "callCenter": _1, "mark": _2, "title": _3, "value": _4 }
